
function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function browserCheck() {
  // Get the User-Agent string from the browser
  var userAgent = navigator.userAgent;
  
  // Check for various browser strings
  if (userAgent.indexOf("Chrome") > -1) {
    var cls = 'browser-chrome';
  } else if (userAgent.indexOf("Firefox") > -1) {
    var cls = 'browser-firefox';
  } else if (userAgent.indexOf("Safari") > -1) {
    var cls = 'browser-safari';
  } else if (userAgent.indexOf("Edge") > -1) {
    var cls = 'browser-edge';
  } else if (userAgent.indexOf("MSIE") > -1 || userAgent.indexOf("Trident/") > -1) {
    var cls = 'browser-ie';
  } else {
    var cls = 'browser-not-detected';
  }

  document.body.classList.add(cls);
}

function loadScriptWithNonce(script, nonce) {
  const newScript = script.cloneNode(true);
  newScript.setAttribute('nonce', nonce);
  newScript.classList.add('new-script');
  // Append the script to the document to start loading
  document.head.appendChild(newScript);
  // console.log(newScript)
  // console.log(newScript.getAttribute('type'))
  if (newScript.textContent) {
      if (newScript.getAttribute('type') !== null && newScript.getAttribute('type').includes('json')) return;
      // console.log(newScript)
      // Use an IIFE (Immediately Invoked Function Expression) to execute the code in a new scope
      (function () {
          eval(newScript.textContent);
      })();
  }
  // newScript.remove();
}

function getScriptTagsWithoutNonce() {
  // const scriptTags = document.querySelectorAll("script");
  // setTimeout(() => {
  //   scriptTags.forEach((scriptTag) => {
  //     const scriptSrc = scriptTag.src;
  //     const currentHost = window.location.host;
  //     if ( !scriptSrc.includes(currentHost) && ( !scriptTag.getAttribute("nonce") || scriptTag.getAttribute("nonce") !== "allow-javascript" ) ) {
  //       // console.log(scriptTag)
  //       loadScriptWithNonce(scriptTag,'allow-javascript')
  //     }
  //   });    
  // }, 100);
}

function disableDuplicateJS() {
  // disables duplicate css link files.
  var nodes       = document.getElementsByTagName("script"),
      foundNodes  = [],
      splitFirst  = 'assets/',
      splitLast   = '.js';
  for (const element of nodes) {
    if (element.src == null && element.getAttribute('data-src') == null) return false;
    var el        = element,
        elSrc     = el.src == null ? el.getAttribute('data-src') : el.src,
        lnk       = elSrc.split(splitFirst).pop().split(splitLast)[0];
    // console.log(elSrc)
    if (elSrc.includes(splitFirst)) {
      if (foundNodes.includes(lnk)) {
        // el.setAttribute('disabled', true);
        el.remove();
      } else {
        foundNodes.push(lnk);
      }
    }
  }
}

function disableDuplicateCSS() {
  // disables duplicate css link files.
  var nodes       = document.getElementsByTagName("link"),
      foundNodes  = [],
      splitFirst  = 'assets/',
      splitLast   = '.css';
  for (const element of nodes) {
    var el        = element,
        elHref    = el.href,
        lnk       = elHref.split(splitFirst).pop().split(splitLast)[0];
    if (elHref.includes(splitFirst)) {
      if (foundNodes.includes(lnk)) {
        el.remove();
      } else {
        if (el.getAttribute('rel') !== 'preload') {
          foundNodes.push(lnk);
        }
      }
    }
  }
}

function disableDuplicateInlineCSS() {
  // disables duplicate inline css style files.
  var nodes           = document.getElementsByTagName("style"),
      foundInlineCSS = [];
  for (const element of nodes) {
    var el        = element,
        elData    = el.dataset.id,
        lnk       = elData;
    if (typeof elData !== 'undefined') {
      if (foundInlineCSS.includes(lnk)) {
        // el.setAttribute('disabled', true);
        el.remove();
      } else {
        foundInlineCSS.push(lnk);
      }
    }
  }
}

function disableDuplicates(argument) {
  disableDuplicateJS();
  disableDuplicateCSS();
  disableDuplicateInlineCSS();
}

function parentVisible(elem) {
  var count = 0,
      elemPar = null,
      nodes = [];
  nodes.push(elem);
  while (
    (elem.parentNode &&
      elem.parentNode.nodeName !== 'BODY' &&
      elem.parentNode.nodeName !== 'HTML' &&
      count < 10)
  ) {
    count++;
    nodes.unshift(elem.parentNode);
    elemPar = elem.parentNode;
    if (elemPar) {
      var styles = window.getComputedStyle(elemPar);
      if (
        styles.display === 'none' ||
        styles.visibility === 'hidden' ||
        styles.opacity === '0'
      ) {
        return false;
      }
    }
  }
  return elemPar;
}

function checkAndLoad(lazyElements,loadLazy) {
  var lazyItems = [].slice.call(document.querySelectorAll(lazyElements));
  if (loadLazy != false) {
    disableDuplicates();
    var visibleLinks = [];
    lazyItems.forEach(function(link, index) {
      var parLink = parentVisible(link);
      if (parentVisible(link)) {
        visibleLinks.push(parLink);
      } else {
        loadItem(link);
      }
    })
    itemIsVisible(visibleLinks,lazyItems);
  } else {
    loadAllItems(lazyItems) 
  }

  function loadItem(el) {
    // el.media='all';
    if (el.nodeName == 'LINK') {
      el.href = el.dataset.href;
    } else {
      el.src = el.dataset.src;
    }
  }

  function itemIsVisible(arr, lazyItems) {
    if ("IntersectionObserver" in window && "IntersectionObserverEntry" in window && "intersectionRatio" in window.IntersectionObserverEntry.prototype) {
      let elObserver = new IntersectionObserver(function(entries, observer) {
        entries.forEach(function(entry) {
          var el = entry.target;
          // console.log(el)
          if ( entry.isIntersecting || ( window.scrollY > (el.offsetTop + el.offsetHeight) ) ) {
            var innerItems = el.querySelectorAll(lazyElements);
            innerItems.forEach(function(item){
              loadItem(item);
            })
            elObserver.unobserve(el);
          }
        });
      });
      arr.forEach(function(el) {
        disableDuplicates();
        elObserver.observe(el);
      });
    } else {
      console.log('observer failed')
      loadAllItems(lazyItems)
    }
  }

  function loadAllItems(lazyItems) {
    disableDuplicates();
    lazyItems.forEach(function(item, index) {
      loadItem(item);
      // console.log(item)
    });
  }
}

function LoadAll() {
  var lazyElements = 'link.lazyload, iframe.lazyload, video.lazyload';
  var lazyScripts  = 'script.lazyload';
  if (!Shopify.designMode) {
    checkAndLoad(lazyElements,true)
    checkAndLoad(lazyScripts,false)
  } else {
    checkAndLoad(lazyElements,false) 
    checkAndLoad(lazyScripts,false)
  }
}

function updateImageSizes(lazyImage) {
  if (lazyImage.offsetWidth < window.innerWidth && lazyImage.offsetWidth > 0) {
    let newSize = Math.round(lazyImage.offsetWidth * 2) + 'px';
    let newLazySize = '(min-width: ' + window.innerWidth + 'px) ' + newSize + ',';
    let lazySizes = lazyImage.dataset.sizes;
    lazySizes = newLazySize + lazySizes;
    lazyImage.dataset.sizes = lazySizes;
  }
}

function LazyImages() {
  // To Do: figure out how to only see "visible" images, not ones hidden in menus till needed
  function isVisible(elem) {
    const styles = window.getComputedStyle(elem)      
    return styles.display !== 'none' && styles.visibility !== 'hidden'
    // return styles.display !== 'none' && styles.visibility !== 'hidden' && parentVisible(elem)
  }

  var lazyClass = 'lazyload',
      loadedClass = 'lazyloaded',
      ignoreClass = 'defer',
      lazyImages = [].slice.call(document.querySelectorAll('img.'+lazyClass+':not(.'+ignoreClass+')'));
  
  setTimeout(function (argument) {

    if ("IntersectionObserver" in window && "IntersectionObserverEntry" in window && "intersectionRatio" in window.IntersectionObserverEntry.prototype) {
      let lazyImageObserver = new IntersectionObserver(function(entries, observer) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting ) {

            let lazyImage = entry.target,
                lazySrc = lazyImage.dataset.src,
                lazySrcSet = lazyImage.dataset.srcset,
                lazySizes = lazyImage.dataset.sizes;

            lazyImage.src = lazySrc;
            lazyImage.srcset = lazySrcSet;
            lazyImage.sizes = lazySizes;
            // updateImageSizes(lazyImage);
            lazyImage.addEventListener('load', loaded)

            function loaded() {
              // setTimeout(function () {
                lazyImage.classList.add(loadedClass);
                lazyImage.classList.remove(lazyClass);
                lazyImageObserver.unobserve(lazyImage);
              // },1000)
            }
          }
        });
      });
      lazyImages.forEach(function(lazyImage) {
        // updateImageSizes(lazyImage);
        lazyImageObserver.observe(lazyImage);
      });
    } else {
      var lazyloadIThrottleTimeout;
      function lazyload () {
        if (lazyloadIThrottleTimeout) {
          clearTimeout(lazyloadIThrottleTimeout);
        }    
        lazyloadIThrottleTimeout = setTimeout(function() {
          var scrollTop = window.pageYOffset;
          lazyImages.forEach(function(img) {
            if (img.offsetTop < (window.innerHeight + scrollTop)) {

              img.src = img.dataset.src;
              img.srcset = img.dataset.srcset;
              img.sizes = img.dataset.sizes;
              img.classList.remove(lazyClass);
              // console.log(img)
            }
          });
          if (lazyImages.length == 0) { 
            document.removeEventListener("scroll", lazyload);
            window.removeEventListener("load", lazyload);
            window.removeEventListener("resize", lazyload);
            window.removeEventListener("orientationChange", lazyload);
          }
        }, 20);
      }
      document.addEventListener("scroll", lazyload);
      window.addEventListener("load", lazyload);
      window.addEventListener("resize", lazyload);
      window.addEventListener("orientationChange", lazyload);
    }
  },100)
}

function updateHeightVar(el, v) {
  var prevH = 0;
  var itm = document.querySelector(el);

  runTwice()
  window.addEventListener('resize', runTwice);
  window.addEventListener('scroll', runTwice);

  function runTwice() {
    initH()
    setTimeout(function() {
      initH(true)
    }, 100);
  }

  function initH(force) {
    var H = !!itm ? itm.clientHeight : 0;
    if (H != prevH || force == true) {
      // console.log('run') 
      // Then we set the value in the --header-height custom property to the root of the document
      document.documentElement.style.setProperty(v, `${H}px`);
      prevH = H;
    }
  }
}

function VideoRatio() {
  let videos = [].slice.call(document.querySelectorAll('iframe[data-video-ratio],video[data-video-ratio]'));
  window.addEventListener("load", initRatio);
  window.addEventListener("resize", initRatio);
  window.addEventListener("orientationChange", initRatio);
  function initRatio() {
    let winWdth         = window.innerWidth,
        ratio           = 0.5625;
    videos.forEach(function(video) {
      if (typeof video.getAttribute('data-video-ratio') !== 'undefined' && video.getAttribute('data-video-ratio') != null) {
        ratio           = video.getAttribute('data-video-ratio') * 0.01;
      }
      let videoPar      = video.closest('div'),
          videoParHght  = videoPar.clientHeight,
          cssHght       = videoParHght,
          cssWdth       = cssHght / ratio;

      if (cssWdth < winWdth) {
        let cssWdth     = winWdth,
            cssHght     = cssWdth * ratio;
      }
      cssWdth           = parseFloat(cssWdth.toFixed(2)); // Round to 2 decimal places
      cssHght           = parseFloat(cssHght.toFixed(2)); // Round to 2 decimal places
      video.setAttribute('style', 'width: ' + cssWdth + 'px !important;height: ' + cssHght + 'px !important;')
    })
  }
}

function watchForElement(el, method) {
  let loopCount = 0,
      loopMax = 100,
      loopDelay = 200;
  let checkIfElementExists = setInterval(function() {
    loopCount++;
    if (loopCount > loopMax) {
      clearInterval(checkIfElementExists);
      // console.log(el + ' not found within ' + loopMax + ' iterations.');
      return false;
    }
    let element = document.querySelectorAll(el)[0]; // Select the element using querySelectorAll
    if (element) {
      clearInterval(checkIfElementExists);
      method(element);
    }
  }, loopDelay);
}

// var chkEl = '[data-testid="ShopifyPay-button"]';
// watchForElement(chkEl,function(el) {
//   el.parent().hide()
// })

function move(elem, moveElemHere, placement) {
  if ( placement == 'before' ) {
    moveElemHere.before(elem);
  } else if ( placement == 'after' ) {
    moveElemHere.after(elem)
  } else if ( placement == 'prepend' ) {
    moveElemHere.prepend(elem)
  } else {
    moveElemHere.append(elem)
  }
}

function positionChange(elemToMove, mobPar, dskPar, mobPlcmt, dskPlcmt, changeAt) {
  var elemToMove    = document.querySelector(elemToMove),
      mobPar        = document.querySelector(mobPar);
  
  if (!elemToMove && !mobPar) return false;

  var dskPar        = elemToMove.closest(dskPar),
      changeAt      = typeof changeAt == 'undefined' ? 750 : changeAt,
      mobPlcmt      = typeof mobPlcmt == 'undefined' ? 'append' : mobPlcmt,
      dskPlcmt      = typeof dskPlcmt == 'undefined' ? 'append' : dskPlcmt,
      mobChk        = 'mob',
      deskChk       = 'desk',
      moved         = deskChk;

  initPos();
  window.addEventListener("resize", initPos);

  function initPos() {
    var wdth        = window.innerWidth,
        above       = wdth >= changeAt && moved != deskChk,
        below       = wdth < changeAt && moved != mobChk;
    if ( above ) {
      move(elemToMove, dskPar, dskPlcmt);
      moved         = deskChk;
    } 
    if ( below ) {
      move(elemToMove, mobPar, mobPlcmt);
      moved         = mobChk;
    } 
  }
}

function getSiblings(elem) {
  // Setup siblings array and get the first sibling
  var siblings = [];
  var sibling = elem.parentNode.firstChild;
  // Loop through each sibling and push to the array
  while (sibling) {
    if (sibling.nodeType === 1 && sibling !== elem) {
      siblings.push(sibling);
    }
    sibling = sibling.nextSibling
  }
  return siblings;
}

function simpleTabs() {
  var dataTitle = 'data-tab-title',
      dataContent = 'data-tab-content',
      dataContainer = 'data-tab-container',
      tabTrigger = '['+dataTitle+']',
      tabContent = '['+dataContent+']',
      tabContainer = '['+dataContainer+']',
      classActiveTab = 'tab--active',
      tabs = document.querySelectorAll(tabTrigger);
  function swapActive(target) {
    var siblings = getSiblings(target);
    siblings.forEach(function (sibling, index) {
      sibling.classList.remove(classActiveTab);
    });
    target.classList.add(classActiveTab); 
  }
  function triggerCustomEvent() {
    var customEvent = new CustomEvent('tabClicked', {
      detail: {
        // message: 'Tab clicked! Custom event triggered.'
        // You can add more data to the 'detail' object if needed
      }
    });
    document.dispatchEvent(customEvent);
  }
  tabs.forEach(function (tab, index) {
    var container = tab.closest(tabContainer),
        tabID = tab.getAttribute(dataTitle),
        content = container.querySelector('['+dataContent+'="'+tabID+'"]');
    tab.addEventListener('click', (event) => {
      event.preventDefault();
      // swap current active tab
      swapActive(tab);
      // swap current active content
      swapActive(content);
      // if needed
      triggerCustomEvent();
    });
    container.querySelector(tabTrigger).click();
  });
}

function getWindowPosition(ratio) {
  // the lower the ratio the closer to the top of window.
  // the higher the ratio the closer to the bottom of window.
  ratio = ratio || 0.5;
  const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
  const windowHeight = window.innerHeight;
  return scrollTop + windowHeight * ratio;
}

function getElementDistanceFromTop(element) {
  const rect = element.getBoundingClientRect();
  const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
  return rect.top + scrollTop;
}

function simpleScrollAnimations() {
  var elementTriggers = document.querySelectorAll('[data-scroll-trigger]'),
      elementInViewClass = 'in-view',
      scrollPos = getWindowPosition(0.9);
  elementTriggers.forEach(function (element, index) {
    var elementContainer = element.closest('[data-scroll-container]'),
        elementScrollOffset = getElementDistanceFromTop(element),
        elementScrollID = element.getAttribute('data-scroll-trigger'),
        elementAddClass = elementContainer.querySelector('[data-scroll-addclass="'+elementScrollID+'"]'),
        isInView = scrollPos >= elementScrollOffset,
        hasClass = elementAddClass.classList.contains(elementInViewClass);

    if (isInView && !hasClass) {
      elementAddClass.classList.add(elementInViewClass);
    } else if (!isInView && hasClass) {
      elementAddClass.classList.remove(elementInViewClass);
    }
  });
}

function wrapRTEiFrame() {
  var iframes = document.querySelectorAll('.rte iframe,.rte video');
  
  iframes.forEach(function (iframe, index) {
    var iframeWrapper = document.createElement('div');

    iframeWrapper.classList.add('video-inline');
    iframe.parentNode.insertBefore(iframeWrapper, iframe);
    iframeWrapper.appendChild(iframe);
  })
}

function LiquidErrorCheck(arr, string) {
  var checkingFor = (string).toLowerCase().toString(), hasError;
  arr.forEach(function (content, index, arr) {
    var check1 = checkString(content.textContent),
        check2 = checkString(content.outerText),
        check3 = checkString(content.outerHTML),
        check4 = checkString(content.innerText),
        check5 = checkString(content.innerHTML);
    hasError = check1 || check2 || check3 || check4 || check5; 
      if (hasError) {
        arr.length = index + 1;
      }
  })
  function checkString(text) {
    return text.toLowerCase().toString().indexOf(checkingFor) > 0;
  }
  if (hasError) {
    console.log('%c\n!!!!!!!!!!!!!!!!!!! \n\nLiquid error found! \n\n!!!!!!!!!!!!!!!!!!!\n ', 'color: red; font-size: 25px');
  } else {
    console.log('%c No liquid errors found. ', 'color: white; background: green; font-size: 16px');
  }
}

function externalLinksOpenNewWindow() {
  // Get all anchor tags on the page
  let anchors = document.getElementsByTagName('a');
  for (let i = 0; i < anchors.length; i++) {
    var noHref = true,
        isDeadLink = false,
        isTel = false,
        isMailTo = false,
        anchor = anchors[i], 
        anchorHref = anchor.getAttribute('href'),
        anchorClasses = anchor.classList,
        isExternal = anchor.host !== window.location.host,
        ignoreClasses = [
          '.ignore-me', 
        ],
        isIgnored = ignoreClasses.some(function(className) {
          return anchorClasses.contains(className);
        });
    if (anchorHref !== null) {
      var noHref = false,
          isDeadLink = anchorHref == '#',
          isMailTo = anchorHref.indexOf('mailto') !== -1,
          isTel = anchorHref.indexOf('tel') !== -1;
    }

    // Check if the link is external
    if (isIgnored || isTel || isMailTo || isDeadLink || noHref) continue;
    if ( isExternal )  {
      // console.log(anchor)

      // Set the target attribute to "_blank" to open in a new window
      anchor.setAttribute('target', '_blank');
    }
  }
}

function smoothScroll() {

  function init(argument) {
    const scrollDuration = 1000,
        hash = window.location.hash;

    if (hash) {
      watchForElement(hash,function(el) {
        setTimeout(function() {
          initSmoothScroll(hash, scrollDuration);
        }, 200);
      })
    }

    // Select all anchor elements with href containing #
    var anchorLinks = document.querySelectorAll('a[href*="#"]');
    
    // Filter out links that match specific href attributes
    var filteredLinks = Array.from(anchorLinks).filter(function(link) {
      var href = link.getAttribute('href');
      return href !== '#' && href !== '#recover' && href !== '#login' && href !== '#0';
    });

    filteredLinks.forEach(anchor => {
      anchor.addEventListener('click', function(e) {
        e.preventDefault();
        var target = this.getAttribute('href');
        initSmoothScroll(target, scrollDuration);
        history.pushState(null, null, target);
      });
    });

  }

  if (document.readyState !== "complete") {
    // Loading hasn't finished yet
    document.addEventListener("DOMContentLoaded", init);
  } else {
    // `DOMContentLoaded` has already fired
    init();
  }
}

function initSmoothScroll(target, duration) {
  var targetElement = target || document.querySelector(target);
  runSmoothScroll(targetElement, duration);
}

function runSmoothScroll(targetElement, duration) {
  if (targetElement) {
    stopDefaultScrolling(); // Stop default scrolling before starting smooth scroll

    let headerWrapper = '.header-wrapper',
        announceWrapper = '.announcement-bar-section',
        headerHeight = document.querySelector(headerWrapper)?.offsetHeight || 0,
        announceHeight = document.querySelector(announceWrapper)?.offsetHeight || 0,
        clearThis = headerHeight + announceHeight + 25, // Adjusted clearThis value
        targetPosition = targetElement.offsetTop - clearThis,
        startPosition = window.pageYOffset,
        distance = targetPosition - startPosition,
        startTime = null;

    function animation(currentTime) {
      if (startTime === null) startTime = currentTime;
      var timeElapsed = currentTime - startTime,
          run = scrollEase(timeElapsed, startPosition, distance, duration);
      window.scrollEase(0, run);
      if (timeElapsed < duration) requestAnimationFrame(animation);
      else {
        resumeDefaultScrolling(); // Resume default scrolling after smooth scroll animation completes
        clearThis = 0; // Clear clearThis value after use
      }
    }

    requestAnimationFrame(animation);
  }
}

// Function to stop default scrolling behavior
function stopDefaultScrolling() {
  window.addEventListener('scroll', stopScrolling, { passive: false });
}

// Function to resume default scrolling behavior
function resumeDefaultScrolling() {
  window.removeEventListener('scroll', stopScrolling, { passive: false });
}

// Function to prevent default scroll behavior
function stopScrolling(event) {
  event.preventDefault();
}

// Easing function for smooth scroll animation
function scrollEase(t, b, c, d) {
  t /= d / 2;
  if (t < 1) return c / 2 * t * t + b;
  t--;
  return -c / 2 * (t * (t - 2) - 1) + b;
}

function scrollPagination() {
  
  var offset = 3; // multiplied by screenheight to triggerNextPage
  var loadedCount = 0;
  var running = false;

  window.addEventListener('scroll', function() {
    init();
  })

  function init(argument) {
    var item = '.pagination__item';
    var list = '.pagination__list';
    var currentAttr = '[aria-current="page"]';
    var infiniteAttr = '[infinite-feed]';
    var items = document.querySelectorAll(item);
    var hasPagination = items[items.length - 1];

    if (hasPagination) {
      var triggerNextPage = hasPagination.offsetTop - (window.innerHeight * offset) < window.scrollY;

      if (triggerNextPage && !running) {
        running = true;

        var currentPageItem = document.querySelector(item+currentAttr);
        if (!currentPageItem) return;

        var nextSiblingItem = currentPageItem.parentNode.nextElementSibling;
        if (!nextSiblingItem) return;

        var nextPageItem = nextSiblingItem.querySelector(item);
        var nextPageUrl = nextPageItem.getAttribute("href");
        var infiniteFeed = document.querySelector(infiniteAttr);

        if (!nextPageUrl || !infiniteFeed) return;

        var xhr = new XMLHttpRequest();
        xhr.open('GET', nextPageUrl, true);

        xhr.onreadystatechange = function() {
          if (xhr.readyState === 4 && xhr.status === 200) {
            var data = xhr.responseText;

            loadedCount++;

            var tempDiv = document.createElement('div');
            tempDiv.innerHTML = data;

            var nextPageItems = tempDiv.querySelectorAll(infiniteAttr+' > *');
            var feedContainer = document.querySelector(infiniteAttr);

            nextPageItems.forEach(function(item) {
              feedContainer.appendChild(item);
            });

            var nextPagePagination = tempDiv.querySelector(list);
            var currentPagination = document.querySelector(list);

            currentPagination.parentNode.replaceChild(nextPagePagination, currentPagination);

            LazyImages();
            checkAndLoad(infiniteAttr+' link.lazyload', true);

            setTimeout(function() {
              running = false;
            }, 500);
          }
        };

        xhr.send();
      }
    }
  }
}

function accordions(eventTarget) {

  // Accordian - Select
  var tabsSelect = document.getElementById('tabs-select');
  if (tabsSelect) {
    tabsSelect.addEventListener('change', function() {
      var url = this.value;
      if (url) {
        var link = document.querySelector('a[href="' + url + '"]');
        if (link) {
          link.click();
        }
      }
    });
  }

  // Sidebar links
  var sidebarLinks = document.querySelectorAll('.accordion-section .sidebar-link');
  if (sidebarLinks.length > 0) {
    sidebarLinks.forEach(function(link) {
      link.addEventListener('click', function(event) {
        event.preventDefault();
        var activeLink = document.querySelector('.accordion-section .sidebar-link.active');
        if (activeLink) {
          activeLink.classList.remove('active');
        }
        this.classList.add('active');
      });
    });
  }

  // Accordian
  var accBtn = '.acc-btn', 
      accBtns = !!eventTarget ? document.querySelector(eventTarget).closest('.shopify-section').querySelectorAll(accBtn) : document.querySelectorAll(accBtn);
  if (accBtns.length > 0) {
    accBtns.forEach(function(btn) {
      var animTime = 300,
          justClickedDelay = 500,
          justClicked = false,
          active = 'selected',
          cont = '.acc-content',
          par = '.acc-container',
          ttlTxt = 'h3',
          imgItm = '.img';
      if (btn.querySelector(ttlTxt).classList.contains(active)) {
        var firstActive = btn.closest(par).querySelector(cont);
        if (!firstActive) return;
        firstActive.style.height = firstActive.firstElementChild.offsetHeight + 'px';
      }

      btn.addEventListener('click', function(event) {
        event.preventDefault();
        var ths = this,
            thsPar = ths.closest(par),
            // must not have '- 1' for section style, 
            // if page style stops working a new solution is needed
            clckdIndx = typeof ths.closest('.site-footer') !== 'undefined' ? Array.prototype.indexOf.call(thsPar.querySelectorAll(accBtn), ths) : 0, 
            //
            conts = thsPar.querySelectorAll(cont),
            inrChldHght = conts[clckdIndx].firstElementChild.offsetHeight,
            thsTtl = thsPar.querySelectorAll(ttlTxt)[clckdIndx],
            thsImg = thsPar.querySelectorAll(imgItm)[clckdIndx],
            thsCont = thsPar.querySelectorAll(cont)[clckdIndx],
            allTtls = thsPar.querySelectorAll(accBtn + ' ' + ttlTxt),
            allImgs = thsPar.querySelectorAll(accBtn + ' ' + imgItm),
            allConts = thsPar.querySelectorAll(cont),
            isOpen = thsTtl.classList.contains(active),
            winWidth = window.innerWidth,
            clearItem = document.querySelector('#shopify-section-header'),
            actTab = document.querySelector(ttlTxt + '.' + active),
            actTabTop = actTab ? actTab.getBoundingClientRect().top + window.scrollY : null;

        // console.log(ths)

        if (!!clearItem && !!actTab) {
          actTabTop = actTabTop + clearItem.offsetHeight + 15;
        }

        event.preventDefault();

        if (!justClicked) {
          justClicked = true;
          if (isOpen) {
            removeClasses();
            openClose();
          } else {
            removeClasses();
            addClasses();
            openClose(true);
          }
          setTimeout(function() {
            justClicked = false;
          }, justClickedDelay);
        }

        function mobScroll() {
          if (winWidth < 750) {
            setTimeout(function() {
              window.scrollTo({
                top: openTabDist,
                behavior: 'smooth'
              });
            }, animTime * 2.5);
          }
        }

        function removeClasses() {
          allTtls.forEach(function(item) {
            item.classList.remove(active);
          });
          allImgs.forEach(function(item) {
            item.classList.remove(active);
          });
          allConts.forEach(function(item) {
            item.classList.remove(active);
          });
        }

        function addClasses() {
          thsTtl.classList.add(active);
          thsImg.classList.add(active);
          thsCont.classList.add(active);
        }

        function zeroHght() {
          conts.forEach(function(item, index) {
            item.style.height = '0px';
          });
        }

        function setHght() {
          conts[clckdIndx].style.height = inrChldHght + 'px';
        }

        function openClose(dir) {
          if (dir == 'open' || dir == true) {
            zeroHght();
            setHght();
          } else {
            setHght();
            zeroHght();
          }
        }
      });
    });
  }
}

function ultimateSlider() {
  var sliderClass = '.nine15--slider',
      sliderTrack = 'slider-track', // is element, not class
      sliders = document.querySelectorAll(sliderClass);

  sliders.forEach(function(slider) {
    var slides = slider.querySelector(sliderTrack);
    var glider = new Glider(slides, sliderSettings(slider));
    
    slides.addEventListener('glider-slide-visible', function(event) {
      LazyImages();
    });
  });

  document.addEventListener('shopify:section:select', function(event) {
    sliders.forEach(function(slider) {
      var slides = slider.querySelector(sliderTrack);
      var glider = new Glider(slides, sliderSettings(slider));
      
      slides.addEventListener('glider-slide-visible', function(event) {
        LazyImages();
      });
    });
  });

  document.addEventListener('shopify:block:select', function(event) {
    sliders.forEach(function(slider) {
      var parentSlider = event.target.closest(sliderClass);

      if (parentSlider) {
        var slides = parentSlider.querySelector(sliderTrack);
        var glider = new Glider(slides, sliderSettings(parentSlider));

        move(event.target, event.target.parentNode.firstElementChild, 'before');
        glider.autoSlideClearInterval();
        glider.setOption({autoSlide: false});
      }
    });
  });

  function sliderSettings(slides) {
    return JSON.parse(slides.getAttribute('data-slider-settings'));
  }
}

function ctasSlider() {
  var sliderClass = '.nine15--ctas.has-slider',
      sliderTrack = '.cell', // is element, not class
      sliders = document.querySelectorAll(sliderClass);

  // console.log(sliders)

  sliders.forEach(function(slider) {
    var slides = slider.querySelector(sliderTrack);
    if (!slides) return false;
    var glider = new Glider(slides, sliderSettings(slides));
    console.log(slider)
    console.log(sliderSettings(slides))

    slider.addEventListener('glider-slide-visible', function(event) {
      LazyImages();
    });
  });

  document.addEventListener('shopify:section:select', function(event) {
    sliders.forEach(function(slider) {
      var slides = slider.querySelector(sliderTrack);
      if (!slides) return false;
      var glider = new Glider(slides, sliderSettings(slides));
      
      slider.addEventListener('glider-slide-visible', function(event) {
        LazyImages();
      });
    });
  });

  function sliderSettings(slides) {
    return JSON.parse(slides.getAttribute('data-slider-settings'));
  }

  // document.addEventListener('shopify:block:select', function(event) {
  //   sliders.forEach(function(slider) {
  //     var parentSlider = event.target.closest(sliderClass);

  //     if (parentSlider) {
  //       var slides = parentSlider.querySelector(sliderTrack);
  //       if (!slides) return false;
  //       var glider = new Glider(slides, JSON.parse(parentSlider.getAttribute(sliderAttr)));

  //       move(event.target, event.target.parentNode.firstElementChild, 'before');
  //       glider.autoSlideClearInterval();
  //       glider.setOption({autoSlide: false});
  //     }
  //   });
  // });
}

function scrollToThemeEditorSection(event) {
  var target = event.target,
      scrollDuration = 300;
  initSmoothScroll(target, scrollDuration);
}

function countdownTimer() {
  let clocks = document.querySelectorAll('.countdown-timer');

  clocks.forEach(function (clock) {
    initCountdown(clock);
  })

  function initCountdown(clock) {
    let endtimeAttr   = clock.getAttribute('data-timer'),
        timerItems    = clock.querySelector('.countdown-timer__items'),
        before        = clock.querySelector('.countdown-timer__deadline--before'),
        after         = clock.querySelector('.countdown-timer__deadline--after'),
        daysElem      = timerItems.querySelector('.days'),    
        hoursElem     = timerItems.querySelector('.hours'),    
        minutesElem   = timerItems.querySelector('.minutes'),    
        secondsElem   = timerItems.querySelector('.seconds');

    if (clock.classList.contains('countdown-is-sticky')) {
      clock.parentNode.classList.add('countdown--sticky');
    }

    let timeinterval = setInterval(() => {
      let t = getTimeRemaining(endtimeAttr);

      setNumber(daysElem,t.days);
      setNumber(hoursElem,t.hours);
      setNumber(minutesElem,t.minutes);
      setNumber(secondsElem,t.seconds);
      
      if (t.total <= 0) {
        clearInterval(timeinterval);
        before.classList.add('hide');
        after.classList.remove('hide');
      }
    }, 1000);
  }

  function setNumber(elem,number) {
    elem.innerHTML = number;
    if (number <= 0) {
      elem.parentNode.classList.add('timer-dim');
    } else {
      elem.parentNode.classList.remove('timer-dim');
    }
  }

  function getTimeRemaining(endtimeAttr) {
    // Get the current time
    let now = new Date();

    let pacificTime = convertToPacificTime(endtimeAttr);

    if (isDaylightSavingsTime(now)) {
      pacificTime.setHours(pacificTime.getHours() - 1); // Subtract one hour for DST
    }

    // Calculate the time difference
    let total = pacificTime.getTime() - now.getTime();

    return {
      total,
      days: formatTimes(total / (1000 * 60 * 60 * 24)),
      hours: formatTimes((total / (1000 * 60 * 60)) % 24),
      minutes: formatTimes((total / (1000 * 60)) % 60),
      seconds: formatTimes((total / 1000) % 60)
    };
  }

  function formatTimes(time) {
    return Math.floor(time).toString().padStart(2, '0');
  }

  function isDaylightSavingsTime(date) {
    const jan = new Date(date.getFullYear(), 0, 1);
    const jul = new Date(date.getFullYear(), 6, 1);
    return date.getTimezoneOffset() < Math.max(jan.getTimezoneOffset(), jul.getTimezoneOffset());
  }

  function convertToPacificTime(inputTime) {
    const containsOffset = /UTC[+-]\d+/.test(inputTime);
    const containsTimezone = /(PDT|PST|Pacific Time)/i.test(inputTime);
    if (!containsOffset && !containsTimezone) {
      const date = new Date(inputTime);
      const pacificTime = date.toLocaleString('en-US', { timeZone: 'America/Los_Angeles' });
      return new Date(pacificTime);
    } else {
      return new Date(inputTime);
    }
  }
}

function loadVideos() {
  let dataVideoID = 'data-video-id',
      dataVideoRatio = 'data-video-ratio',
      youtubeVideos = document.querySelectorAll('.youtube-video'),
      vimeoVideos = document.querySelectorAll('.vimeo-video'),
      delayLoad = 2000;

  if (youtubeVideos.length > 0) {
    createScript(document.body, "https://www.youtube.com/iframe_api");
  }
  if (vimeoVideos.length > 0) {
    createScript(document.body,"https://player.vimeo.com/api/player.js")
  }

  window.onYouTubeIframeAPIReady = function() {
    youtubeVideos.forEach(function(video) {
      youtube(video);
    });
  };

  waitForVimeo(function() {
    vimeoVideos.forEach(function(video) {
      vimeo(video);
    });
  });

  function youtube(video) {
    let videoID = video.getAttribute(dataVideoID),
        videoRatio = video.getAttribute(dataVideoRatio),
        trueIfAutoplay = (video.getAttribute('data-autoplay') === 'true') ? 1 : 0,
        falseIfAutoplay = !trueIfAutoplay ? 1 : 0,
        delay = trueIfAutoplay ? 0 : delayLoad,
        playerID = video.id;

    setTimeout(() => {
      let player = new YT.Player(playerID, {
        height: '720',
        width: '1280',
        videoId: videoID,
        playerVars: {
          'autoplay': trueIfAutoplay,
          'mute': trueIfAutoplay,
          'loop': trueIfAutoplay,
          'controls': falseIfAutoplay,
          'rel': 0,
          'showinfo': 0,
          'fs': falseIfAutoplay,
          'modestbranding': trueIfAutoplay,
          'disablekb': trueIfAutoplay,
          'iv_load_policy': 3
        },
        events: {
          'onReady': function(event) { 
            onPlayerReady(event, video, videoRatio); 
          },
          'onStateChange': onPlayerStateChange
        }
      },delay)
    });

    function onPlayerReady(event, video, videoRatio) {
     
      let iframe = event.target.g;
      iframe.setAttribute(dataVideoRatio, videoRatio);
      VideoRatio()

      // if (trueIfAutoplay) {
      //   setTimeout(function (iframe) {
      //     iframe.playVideo();
      //   },1000)
      // }
    }

    function onPlayerStateChange(event) {
      if (event.data == YT.PlayerState.ENDED) {
        // Video ended
      }
    }
  }

  function vimeo(video) {

    try {
      let videoID = video.getAttribute(dataVideoID),
          videoRatio = video.getAttribute(dataVideoRatio),
          trueIfAutoplay = (video.getAttribute('data-autoplay') === 'true') ? 1 : 0,
          falseIfAutoplay = !trueIfAutoplay ? 1 : 0,
          delay = trueIfAutoplay ? 0 : delayLoad,
          playerID = video.id;

      applyVimeoThumbnail(videoID, video);

      setTimeout(() => {
        let player = new Vimeo.Player(playerID, {
          id: videoID,
          width: 1280,
          height: 720,
          autoplay: trueIfAutoplay,
          muted: trueIfAutoplay,
          loop: trueIfAutoplay,
          controls: falseIfAutoplay,
          title: falseIfAutoplay,
          byline: falseIfAutoplay,
          portrait: falseIfAutoplay
        });

        observeAndReplace(video, function(target) {
          video.parentNode.replaceChild(target, video);
          target.setAttribute(dataVideoRatio, videoRatio);
          VideoRatio();
        });

        // if (trueIfAutoplay) {
        //   setTimeout(function (iframe) {
        //     player.play();
        //   },1000)
        // }

        // player.on('play', function() {
        //   console.log('Vimeo video started playing');
        // });

        // player.on('error', function(error) {
        //   console.error('Vimeo player error:', error);
        // });

        // player.on('loaded', function() {
        //   console.log('Vimeo player loaded');
        // });

      },delay)
    } catch (error) {
      console.error('Error initializing Vimeo player:', error);
    }
  }

  function applyVimeoThumbnail(videoId, elem) {
    let apiUrl = `https://vimeo.com/api/v2/video/${videoId}.json`;

    fetch(apiUrl)
      .then(response => response.json())
      .then(data => {
        if (data && data[0] && data[0].thumbnail_large) {
          let thumbnailUrl = data[0].thumbnail_large;
          elem.style.setProperty('--background-image', `url(${thumbnailUrl})`);
        } else {
          console.log('Thumbnail not found or error occurred.');
        }
      })
      .catch(error => {
        console.error('Error fetching Vimeo video information:', error);
      });
  }

  function waitForVimeo(method) {
    if (window.Vimeo) {
      method();
    } else {
      setTimeout(function() { waitForVimeo(method) }, 10);
    }
  }

  function createScript(parent, url, onload) {
    if (document.querySelectorAll('[src="'+url+'"]').length <= 0) {
      let tag = document.createElement('script');
      tag.src = url;
      if (onload && typeof onload === 'function') {
        tag.onload = onload;
      }
      parent.appendChild(tag);
      // console.log('Script loaded:', url); // Add this line
    }
  }

  function observeAndReplace(video, method) {
    const observer = new MutationObserver((mutationsList, observer) => {
      for (const mutation of mutationsList) {
        if (mutation.type === 'childList') {
          for (const node of mutation.addedNodes) {
            if (node.nodeType === Node.ELEMENT_NODE) {
              method(node); // Calling the method function with the new node as an argument
            }
          }
        }
      }
    });
    observer.observe(video, { childList: true, subtree: true });
  }
}

smoothScroll()


function OtherInputField(e) {
  var select_value = e.value.toLowerCase();

  var gridItem = e.closest('.cell__item');
  var hideOthersElements = gridItem.querySelectorAll('.hide-others');

  function showHideElements(show) {
    hideOthersElements.forEach(function(element) {
      if (show) {
        element.classList.remove('hide');
      } else {
        element.classList.add('hide');
      }
    });
  }

  if ((e || {}).type === 'checkbox') {
    if (select_value.includes('other')) {
      if (e.checked) {
        showHideElements(true);
      } else {
        showHideElements(false);
      }
    }
  } else {
    if (select_value.includes('other')) {
      showHideElements(true);
    } else {
      showHideElements(false);
    }
  }
}
function fillHidden(hiddenname) {
  var checkboxes = document.querySelectorAll('[hidden-data="' + hiddenname + '"]');
  var hiddenfield = document.getElementById(hiddenname);
  hiddenfield.value = ""
  var i;
  for (i = 0; i < checkboxes.length; i++) {
    var x = checkboxes[i];
    if (x.checked) {
      if (hiddenfield.value == "") {
        hiddenfield.value = x.value;
      } else {
        hiddenfield.value = hiddenfield.value + ", " + x.value;
      }
    }
  }
}

const container = document.querySelector('.pages-container');
let currentIndex = 0;

function moveSlide(direction) {

  container.style.overflowX = 'hidden';

  const tabs = container.parentNode.querySelectorAll('.tabs [data-tab]');
  const progressBar = container.parentNode.querySelector('.progress-bar');

  const items = container.querySelectorAll('.item');
  currentIndex = Math.min(Math.max(currentIndex + direction, 0), items.length - 1);

  tabs.forEach((tab, index) => {
    if (index === currentIndex) {
      tab.classList.add('active');
    } else {
      tab.classList.remove('active');
    }
  });

  const currentPage = parseInt(progressBar.style.getPropertyValue('--current-page')) || 0;
  progressBar.style.setProperty('--current-page', currentPage + direction);

  const itemWidth = items[0].offsetWidth;
  const scrollPosition = itemWidth * currentIndex;

  container.scrollTo({
    left: scrollPosition,
    behavior: 'smooth'
  });

  setTimeout(() => {
    container.style.overflowX = 'hidden';
  }, 1000); 

}

function validateAge(e) {
  const day = document.getElementById('day').value;
  const month = document.getElementById('month').value;
  const year = document.getElementById('year').value;

  const monthNames = {
    "January": 0,
    "February": 1,
    "March": 2,
    "April": 3,
    "May": 4,
    "June": 5,
    "July": 6,
    "August": 7,
    "September": 8,
    "October": 9,
    "November": 10,
    "December": 11
  };

  const monthIndex = monthNames[month];

  if (!day || !month || !year || day === "Day" || month === "Month" || year === "Year" || monthIndex === undefined) {
    alert("Please select a valid date.");
    e.preventDefault();
    return false;
  }

  const birthDate = new Date(year, monthIndex, day);
  const today = new Date();
  let age = today.getFullYear() - birthDate.getFullYear();
  const m = today.getMonth() - birthDate.getMonth();

  if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
    age--;
  }

  if (age < 18) {
    alert("Must be at least 18 years old.");
    e.preventDefault();
    return false;
  }
  return true;
}



document.addEventListener('DOMContentLoaded', function () {

  // only for testing, should not be left on
  // LiquidErrorCheck([document.head,document.body],'Liquid error');

  browserCheck()

  scrollPagination()

  externalLinksOpenNewWindow()

  loadVideos()
  // VideoRatio()
  
  wrapRTEiFrame();

  window.addEventListener('scroll', () => {
    simpleScrollAnimations();
  });
  setTimeout(function (argument) {
    simpleScrollAnimations();
  }, 500)

  disableDuplicates();
  
  simpleTabs();

  accordions();

  countdownTimer();

});

waitForSlider(function () {
  ultimateSlider();
  ctasSlider();
})

function reInitForThemeEditor() {
  LoadAll();
  accordions();
  ultimateSlider();
  ctasSlider();
  LazyImages();
  loadVideos();
  // countdownTimer();
}

var customJSisLoaded = true;
